import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { endOfMonth, startOfMonth } from 'date-fns';

export const hasPaidThisMonth = (paymentHistory) => {
  if (!paymentHistory || paymentHistory.length === 0) {
    return false;
  }

  const currentMonthStart = startOfMonth(new Date());
  const currentMonthEnd = endOfMonth(new Date());

  return paymentHistory.some((payment) => {
    const paymentDate = payment.timestamp?.seconds
      ? new Date(payment.timestamp.seconds * 1000)
      : null;

    if (!paymentDate) {
      return false;
    }

    return paymentDate >= currentMonthStart && paymentDate <= currentMonthEnd;
  });
};

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatNumber = (value) => {
  return value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export function formatPhoneNumber(phoneNumber) {
  const formattedNumber = phoneNumber.replace(
    /(\+998)(\d{2})(\d{3})(\d{2})(\d{2})/,
    '$1 $2 $3 $4 $5'
  );
  return formattedNumber;
}

export const formatDate = (timestamp, showTime = false) => {
  if (!timestamp) return '-';

  const date = timestamp.seconds
    ? new Date(timestamp.seconds * 1000)
    : new Date(timestamp);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  if (showTime) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}.${month}.${year} - ${hours}:${minutes}`;
  }

  return `${day}.${month}.${year}`;
};

export function formatJSONDate(obj) {
  // Extract year, month, and day from the object
  const day = String(obj?.day).padStart(2, '0'); // Ensure two-digit day
  const month = String(obj?.month).padStart(2, '0'); // Ensure two-digit month
  const year = obj?.year;

  // Format to "dd.mm.yyyy"
  return `${day}.${month}.${year}`;
}

export function formatPaymentMethod(method) {
  switch (method) {
    case 'cash':
      return 'Naqd pul';
    case 'credit_card':
      return 'Kredit karta';
    case 'bank_transfer':
      return 'Bank oʻtkazmasi';
    default:
      return 'Nomaʼlum usul';
  }
}

export function translateMonthToUzbek(monthName) {
  switch (monthName.toLowerCase()) {
    case 'january':
      return 'Yanvar';
    case 'february':
      return 'Fevral';
    case 'march':
      return 'Mart';
    case 'april':
      return 'Aprel';
    case 'may':
      return 'May';
    case 'june':
      return 'Iyun';
    case 'july':
      return 'Iyul';
    case 'august':
      return 'Avgust';
    case 'september':
      return 'Sentabr';
    case 'october':
      return 'Oktabr';
    case 'november':
      return 'Noyabr';
    case 'december':
      return 'Dekabr';
    default:
      return 'Invalid month';
  }
}

export function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
}

export function formatDateTime(dateValue) {
  if (!dateValue) return null;

  // If it's already a Date object, return it
  if (dateValue instanceof Date) {
    return dateValue;
  }

  // If it's a CalendarDateTime object from react-aria-components
  // It may have a toDate method or we can construct a Date from properties
  if (dateValue.year && dateValue.month !== undefined && dateValue.day) {
    // Try using toDate method if available (CalendarDateTime from @internationalized/date)
    if (typeof dateValue.toDate === 'function') {
      return dateValue.toDate();
    }

    // Otherwise, construct a Date from the properties
    // Note: month is 1-indexed in CalendarDateTime, 0-indexed in JavaScript Date
    const year = dateValue.year;
    const month = dateValue.month - 1;
    const day = dateValue.day;
    const hour = dateValue.hour || 0;
    const minute = dateValue.minute || 0;
    const second = dateValue.second || 0;

    return new Date(year, month, day, hour, minute, second);
  }

  // If it's a timestamp object with seconds (Firestore Timestamp)
  if (dateValue.seconds) {
    return new Date(dateValue.seconds * 1000);
  }

  // Try to parse it as a date string
  return new Date(dateValue);
}

export function scoreColor(score) {
  if (score === null || score === undefined || score === '-') {
    return 'text-muted-foreground';
  }

  const percentage = typeof score === 'number' ? score : parseFloat(score);

  if (isNaN(percentage)) {
    return 'text-muted-foreground';
  }

  if (percentage >= 90) {
    return 'text-green-600 dark:text-green-500';
  } else if (percentage >= 70) {
    return 'text-green-500 dark:text-green-400';
  } else if (percentage >= 50) {
    return 'text-yellow-500 dark:text-yellow-400';
  } else {
    return 'text-red-500 dark:text-red-400';
  }
}